import { Component, Input } from '@angular/core'

@Component({
  selector: 'ccg-rating',
  templateUrl: './rating.component.html',
  styleUrl: './rating.component.scss',
  standalone: false
})
export class RatingComponent {
  rating = 0
  overallWidth = 0
  @Input()
    dark: boolean = false

  @Input() set setRating (ratingToSet: number) {
    this.rating = this.getAdjustedRating(ratingToSet)
    this.overallWidth = this.rating * 100 / 5
  }

  getAdjustedRating (rating: number): number {
    const floorValue = Math.floor(rating)
    const rounded = Math.round(rating * 100) / 100
    const decimalValue = parseFloat((rounded - floorValue).toFixed(2))

    if (decimalValue < 0.25) {
      return floorValue
    } else if (decimalValue < 0.75) {
      return floorValue + 0.5
    }
    return floorValue + 1
  }
}
